<template>
  <a :href="uploadPhotoPath" class="flex justify-between items-center p-16">
    <div>
      <p class="text-strong-body text-grey-header">Upload your profile picture</p>
      <p class="text-body-3 mt-4">Putting a face to a name helps build trust</p>
    </div>
    <DisclosureIcon :width="16" :height="16" class="sm:w-24 sm:h-24" />
  </a>
</template>

<script lang="ts">
import DisclosureIcon from '@/graphics/icons/DisclosureIcon.vue';

export default {
  name: 'PhotoUploadTask',
  components: { DisclosureIcon },
  computed: {
    uploadPhotoPath(): string {
      return '/sitter/photo_upload#/sitter_upload';
    },
  },
};
</script>
